import { render, staticRenderFns } from "./HomeDashboard.vue?vue&type=template&id=25f08c89&scoped=true"
import script from "./HomeDashboard.vue?vue&type=script&lang=js"
export * from "./HomeDashboard.vue?vue&type=script&lang=js"
import style0 from "./HomeDashboard.vue?vue&type=style&index=0&id=25f08c89&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25f08c89",
  null
  
)

export default component.exports